import { createContext } from 'react'

export interface AppUpdateContextValue {
  /** 새 자산이 준비됐는지. 확인 전이거나 같은 자산이면 거짓이다. */
  ready: boolean
  /** 다시 열기를 눌러 화면이 다시 서기를 기다리는 중인지. */
  reopening: boolean
  reopen: () => void
}

export const AppUpdateContext = createContext<AppUpdateContextValue | null>(null)
